var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chat-list" } },
    [
      _c("supsis-table", {
        attrs: {
          columns: _vm.columns,
          rows: _vm.getData(),
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
          "empty-data-bordered": false,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("div"),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "tableSettingsBtn" },
                      [
                        _c("a-icon", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                            },
                          ],
                          style: { color: "#3699FF" },
                          attrs: {
                            id: "tableSettingsButton",
                            content: _vm.$t("message.tableSettingTippy"),
                            "data-v-step": "12",
                            type: "setting",
                          },
                          on: { click: _vm.showModal },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "emptyData",
            fn: function () {
              return [_c("NoChatFound")]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.selectedItem
        ? _c(
            "div",
            {
              style: {
                top: _vm.contextOpt.top + "px",
                left: _vm.contextOpt.left + "px",
              },
              attrs: { id: "context-menu" },
              on: {
                blur: function ($event) {
                  _vm.selectedItem = null
                },
                mouseleave: function ($event) {
                  _vm.selectedItem = null
                },
              },
            },
            [
              _c("div", { staticClass: "d-flex flex-column" }, [
                (_vm.selectedItem.users || []).length === 0 || _vm.fakeMode
                  ? _c(
                      "div",
                      {
                        staticClass: "ctx-btn",
                        staticStyle: { "margin-left": "0 !important" },
                        attrs: { id: "joinChat" },
                        on: {
                          click: function ($event) {
                            return _vm.join(_vm.selectedItem)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.join").toUpperCase())),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ((_vm.selectedItem.users || []).filter(function (w) {
                  return w === _vm.user._id
                }).length === 0 &&
                  !_vm.observing.includes(_vm.selectedItem._id)) ||
                _vm.fakeMode
                  ? _c(
                      "div",
                      {
                        staticClass: "ctx-btn",
                        on: {
                          click: function ($event) {
                            return _vm.observe(_vm.selectedItem)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.watch").toUpperCase())),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "tableColumns",
                title: _vm.$t("message.tableSettings"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.$t("message.tableSettingsInfo")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tableSettings" },
                _vm._l(_vm.defaultCols, function (col, i) {
                  return col.name !== "actions"
                    ? _c("div", { key: col.key }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                on: { input: _vm.toLocalStorage },
                                model: {
                                  value: _vm.tableCols[col.key],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.tableCols, col.key, $$v)
                                  },
                                  expression: "tableCols[col.key]",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    col.title ? col.title : _vm.titleEmpty()
                                  ) + "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.$t("message.privateParametry")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tableSettings" },
                _vm._l(_vm.visitorAttributes, function (col) {
                  return _c(
                    "div",
                    { key: col.name, staticClass: "item" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          on: { input: _vm.toLocalStorage },
                          model: {
                            value: _vm.tableCols[col.name],
                            callback: function ($$v) {
                              _vm.$set(_vm.tableCols, col.name, $$v)
                            },
                            expression: "tableCols[col.name]",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(col.label) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.$t("message.systemOperetor")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tableSettings" },
                _vm._l(_vm.systemOperetor, function (col) {
                  return _c(
                    "div",
                    { key: col.key, staticClass: "item" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            disabled:
                              Object.values(_vm.tableCols).filter(function (x) {
                                return x === true
                              }) && !_vm.customLoginFormEnabled,
                          },
                          on: { input: _vm.toLocalStorage },
                          model: {
                            value: _vm.tableCols[col.key],
                            callback: function ($$v) {
                              _vm.$set(_vm.tableCols, col.key, $$v)
                            },
                            expression: "tableCols[col.key]",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(col.title ? col.title : _vm.titleEmpty()) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }